import { ChangeDetectionStrategy, Component, input, Pipe, PipeTransform } from "@angular/core";
import { AccountGroup } from "@front/m19-models";
import { IBadgeComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Pipe({ name: "hasBidderOn" })
export class HasBidderOnPipe implements PipeTransform {
  transform(accountGroup: AccountGroup): boolean {
    return accountGroup.getAccountMarketplacesWithBidderOn().length > 0;
  }
}
@Component({
  selector: "app-account-group-selector-option",
  imports: [IBadgeComponent, HasBidderOnPipe, TranslocoDirective],
  template: `
    <div class="flex items-center justify-between pr-2" *transloco="let t">
      <span class="truncate">{{ accountGroup().name }}</span>
      <div class="flex items-center gap-1">
        @if (accountGroup() | hasBidderOn) {
          <IBadge variant="soft" [label]="t('account-selector.ads_automation')" size="xs" />
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountGroupSelectorOptionComponent {
  public readonly accountGroup = input.required<AccountGroup>();
}
